'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnimator = getAnimator;
exports.createAnimator = createAnimator;
exports.removeAnimator = removeAnimator;
exports.removeAnimatorsForLayer = removeAnimatorsForLayer;

var _Animator = require('./Animator');

var _Animator2 = _interopRequireDefault(_Animator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animators = {};

function getAnimator(layer, key) {
  var layerID = layer.getID();
  return animators[layerID] && animators[layerID][key];
}

function createAnimator(layer, key, config) {
  var layerID = layer.getID();
  if (!animators[layerID]) {
    animators[layerID] = {};
  }
  if (animators[layerID][key]) {
    animators[layerID][key].stop();
  }
  animators[layerID][key] = new _Animator2.default(layer, key, config);
  return animators[layerID][key];
}

function removeAnimator(layer, key) {
  var layerID = layer.getID();
  if (animators[layerID] && animators[layerID][key]) {
    animators[layerID][key].stop();
    delete animators[layerID][key];
  }
}

function removeAnimatorsForLayer(layer) {
  var layerID = layer.getID();
  if (animators[layerID]) {
    Object.keys(animators[layerID]).forEach(function (key) {
      animators[layerID][key] && animators[layerID][key].stop();
    });
    delete animators[layerID];
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/AnimatorManager.js
// module id = 166
// module chunks = 0